<template>
  <div class="col-md-6">
    <div class="box box-primary">
      <div class="box-header with-border">
        <i class="fa fa-signal"></i>
        <h3 class="box-title">{{title}}</h3>
        <div class="box-tools pull-right">
          <button
            type="button"
            class="btn btn-box-tool"
            data-widget="collapse"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="box-body">
        <!--饼图-->
        <div class="chart">
          <canvas
            ref="canvas"
            class="test-device-analysis-chart"
          ></canvas>
        </div>
        <!--饼图-->
      </div>
      <!-- /.box-body-->
    </div>
    <!-- /.box -->
  </div>
</template>
<script>
import api from "../../api";
import Chart from "../../../static/js/plugins/chartjs/Chart.js";

const colors = [
  {
    color: "#F7464A",
    highlight: "#FF5A5E"
  },
  {
    color: "#46BFBD",
    highlight: "#5AD3D1"
  },
  {
    color: "#FDB45C",
    highlight: "#FFC870"
  },
  {
    color: "#00a4f2",
    highlight: "#19b2ff"
  }
];

export default {
  name: "analysis-chart",
  props: {
    path: {
      required: true
    },
    type: {
      required: true
    },
    title: {
      required: true
    }
  },
  data() {
    return {
      isFetching: true,
      barData: {
        labels: [],
        datasets: [
          {
            label: "Connection Info",
            fillColor: "rgba(220,220,220,0.5)",
            strokeColor: "rgba(220,220,220,0)",
            highlightFill: "rgba(220,220,220,0.75)",
            highlightStroke: "rgba(220,220,220,0)",
            data: []
          }
        ]
      },
      pieData: []
    };
  },
  mounted() {
    this.charType = "Bar";
    this.fetch();
  },
  methods: {
    xTypes(resp) {
      const { type, barData, pieData } = this;
      const { labels, datasets } = barData;
      const dataset = datasets[0];
      const { data: d } = dataset;
      if (type === "monthly") {
        const color = colors[0];
        dataset.highlightFill = color.highlight;
        dataset.fillColor = color.color;
        resp
          .map(item => {
            item._date = new Date(`${item.date.year}-${item.date.month}`);
            return item;
          })
          .sort((a, b) => (a._date > b._date ? 1 : -1))
          .forEach(({ count, date: { month, year } }) => {
            labels.push(`${year}-${month}`);
            d.push(count);
          });
      } else if (type === "daily") {
        const color = colors[1];
        dataset.highlightFill = color.highlight;
        dataset.fillColor = color.color;
        resp
          .map(item => {
            item._date = new Date(
              `${item.date.year}-${item.date.month}-${item.date.date}`
            );
            return item;
          })
          .sort((a, b) => (a._date > b._date ? 1 : -1))
          .forEach(({ count, date: { month, year, date } }) => {
            labels.push(`${year}-${month}-${date}`);
            d.push(count);
          });
      } else if (type === "duration") {
        this.charType = "Pie";
        resp
          .sort((a, b) =>
            parseInt(a.duration, 10) > parseInt(b.duration, 10) ? 1 : -1
          )
          .forEach(({ count, duration }, index) => {
            const color = colors[index];
            pieData.push({
              ...color,
              value: count,
              label: duration.replace(/^\d+\)/, "")
            });
          });
      } else {
        const color = colors[2];
        dataset.highlightFill = color.highlight;
        dataset.fillColor = color.color;
        const max = 10;
        const total = resp.length;
        const lastIndex = Math.max(total - max, max);
        resp
          .sort((a, b) => (a.count > b.count ? 1 : -1))
          .filter((_, index) => index >= lastIndex)
          .forEach(({ count, label }) => {
            labels.push(label);
            d.push(count);
          });
      }
    },
    async fetch() {
      const result = await api.post({
        path: `/analysis/${this.path}?_type=json`,
        data: { appid: this.$route.query.appid }
      });
      this.isFetching = false;
      const resp = JSON.parse(result.dataset);
      this.xTypes(resp);
      this.renderChart();
    },
    renderChart() {
      const { barData, pieData } = this;
      var areaChartCanvas = this.$refs.canvas.getContext("2d");
      var areaChart = new Chart(areaChartCanvas);
      areaChart[this.charType](this.charType === "Bar" ? barData : pieData, {
        legendTemplate:
          '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"><%if(segments[i].label){%><%=segments[i].label%><%}%></span></li><%}%></ul>'
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// AnalysisChart.vue?5504230c